<template>
  <div>
    <a href="#" @click.prevent="currentPicture = attachment.full_path; $refs.modalShowPicture.show()">
      <b-media vertical-align="center" class="align-items-center">
        <template #aside>
          <div style="width: 60px; max-height: 60px;" class="d-flex justify-content-center align-items-center" v-if="!attachmentIsPdf(attachment.full_path)">
            <img :src="attachment.full_path" alt="" style="max-height: 60px;" class="img-thumbnail" />
          </div>
          <div style="width: 60px; height: 60px;" class="d-flex justify-content-center align-items-center img-thumbnail" v-else>
            <font-awesome-icon icon="file-pdf" style="font-size: 30px; vertical-align: middle;" class="text-danger"/>
          </div>
        </template>
        <h6 class="mb-0">{{statusStrings[attachment.type] || attachment.type}} <b-badge variant="dark" v-if="attachment.source === 'web'">web</b-badge></h6>
        <div class="text-muted" v-translate="{userName: attachment.applied_by?.name || 'NN', createdAt: moment.utc(attachment.created_at).tz($tz).format('L LT')}">
          By <strong>%{userName}</strong> on <strong>%{createdAt}</strong>
        </div>
        <div v-if="attachment.applied_by?.company?.name" class="text-muted">{{attachment.applied_by.company.name}}</div>
        <div v-if="attachment.comment" v-html="$options.filters.brize(attachment.comment)"></div>
      </b-media>
    </a>
    <b-modal ref="modalShowPicture" size="lg" id="modalShowPicture" hide-footer>
      <div slot="modal-title" v-translate>View Document</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <div class="w-100">
        <img :src="currentPicture" alt="" class="w-100" v-if="!attachmentIsPdf(attachment.full_path)">
        <embed :src="currentPicture +'?#scrollbar=0&toolbar=1&navpanes=0'" type="application/pdf" class="w-100" style="height: 85vh;" v-else>
      </div>
    </b-modal>
  </div>
</template>

<script>
import constants from '@/common/constants'

export default {
  name: 'ShippingFilesListItemFullPath',
  props: {
    attachment: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      currentPicture: null
    }
  },
  mixins: [constants],
  methods: {
    attachmentIsPdf(url) {
      return (url = url.substr(1 + url.lastIndexOf('/')).split('?')[0].split('#')[0]).substr(url.lastIndexOf('.')) === '.pdf'
    }
  }
}
</script>

<style lang="css" scoped>
a:hover {
  text-decoration: none !important;
}
</style>
